export default {
  data: {
    value: '',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/visitas/kmValue/components/search/search-form.js